import { render } from "./ModelDetail.vue?vue&type=template&id=e16cc776"
import script from "./ModelDetail.vue?vue&type=script&lang=js"
export * from "./ModelDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__